import React, { useState } from 'react';
import './contact.css'
import INCSUBCommonHeading from '../../commonComponents/commonHeading/commonHeading';
import INCSUBFooter from '../../components/Footer/Footer';
import { toast } from 'react-toastify';

function INCSUBContact() {

  const [error, setError] = useState(false); // to handle error
  const [isSuccess, setIsSuccess] = useState(false);
  const [isValidMail, setIsValidMail] = useState(false)
  const [email, setEmail] = useState('');
  const [name, setName] = useState('')
  const [message, setMessage] = useState('');
  const [number, setNumber] = useState('')
  const [inValidNumber, setInValidNumber] = useState(false); //to number validation


  /**
 * @function isValidEmail
 * @author Vishal Lohbande
 * @description
 * Validates whether a given string is a properly formatted email address.
 * 
 * Uses a regular expression to check that the email:
 * - Has no leading/trailing whitespace
 * - Contains exactly one '@' symbol
 * - Contains a domain with at least one dot '.' after '@'
 * 
 * This function does a basic syntactic check and does not guarantee the email exists.
 * 
 * @param {string} email - The email address string to validate.
 * @returns {boolean} Returns `true` if the email is valid, otherwise `false`.
 * 
 * Usage:
 * ```js
 * if (isValidEmail(userInput)) {
 *   // Proceed with valid email
 * } else {
 *   // Show error message
 * }
 * ```
 */
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }



  /**
 * @function handleMessage
 * @description Updates the `message` state based on user input in the message field.
 * @param {React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>} e - The input change event.
 */
  const handleMessage = (e) => setMessage(e.target.value);


  /*function to check the provided mobile no is valid or not*/
  /**
  * @function isValidMobile
  * @author Vishal Lohbande
  *
  * Description:
  * - Validates whether the input string is either a valid Indian mobile number or a valid email address.
  * - Uses two regular expressions:
  *   - `mobileRegex`: Matches a 10-digit Indian mobile number starting with digits 6-9.
  *   - `emailRegex`: Matches a general email address format.
  * - Returns `true` if the input matches either pattern, otherwise returns `false`.
  *
  * Usage:
  * - Used to validate user inputs that accept either a mobile number or an email address.
  *
  * Notes:
  * - The mobile number regex strictly matches Indian mobile numbers.
  * - The email regex covers common email patterns but may not capture all valid emails.
  *
  * Example:
  * ```js
  * isValidMobile('9876543210');  // true
  * isValidMobile('user@example.com');  // true
  * isValidMobile('12345');  // false
  * ```
  */
  const isValidMobile = (input) => {
    const mobileRegex = /^[6-9]\d{9}$/; // Indian mobile number pattern (10 digits, starts with 6-9)
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // General email pattern

    if (mobileRegex.test(input)) {
      return true;
    } else if (emailRegex.test(input)) {
      return true;
    } else {
      return false;
    }
  };


/**
 * @constant stdData
 * @author Vishal Lohbande
 * @description
 * An object representing the initial state or template for standard user input data.
 * 
 * Properties:
 * - `name` {string}: User's full name, initially empty.
 * - `email` {string}: User's email address, initially empty.
 * - `message` {string}: User's message or query, initially empty.
 * 
 * Usage:
 * Used as a baseline data structure for forms or input fields to collect user information.
 */
  var stdData = {
    name: '',
    email: '',
    message: '',
    number: ''
  }


  /**
 * @async
 * @function handleSubmit
 * @author Vishal Lohbande
 * @description
 * Handles the submission of a contact form by validating input fields, sending the data
 * via a POST request to a Google Apps Script endpoint, and managing UI feedback states.
 * 
 * The function:
 * - Sets an optimistic success state initially.
 * - Validates that `name`, `email`, and `message` are not empty or null.
 * - If validation fails, sets an error state and stops further execution.
 * - Constructs a `FormData` object including the current date and form fields.
 * - Sends the data asynchronously using fetch.
 * - On success, shows a success toast notification and resets form inputs and states.
 * - On failure, resets the success state and handles errors silently.
 * 
 * @param {Event} e - The form submit event object.
 * @returns {void}
 */
  const handleSubmit = async (e) => {
    setIsSuccess(true)
    stdData = {
      name: name,
      email: email,
      message: message,
      number: number

    }


    const isInvalid = [
      stdData.name,
      stdData.email,
      stdData.message,
      stdData.number,


    ].some(field => field === null || field === '');


    if (isInvalid) {
      setError(true);
      setIsSuccess(false);
      return;
    }

      
   if (!isValidMobile(stdData.number)) {
      setIsSuccess(false);
      setInValidNumber(true);
      return;
    }

    const formData = new FormData();
    formData.append('date', new Date());
    Object.keys(stdData).forEach(key => {
      formData.append(key, stdData[key]);
    });
  
    try {
      const response = await fetch('https://script.google.com/macros/s/AKfycbwQsYt_oruQePCvYLHVjOv1pyaECAO1UmMQMP3ijkG0fd__rzGct4X3kwi0Hmwxcw2Fcg/exec', {
          method: 'POST',
          body: formData
      });

      if (!response.ok) throw new Error('Network error or script issue');
      toast.success('send Successfully', {autoClose: 1000})
      // Reset on success
      setIsSuccess(false);
      setError(false)
      stdData = {
        name: '',
        email: '',
        message: '',
        number: ''
      };

      setName('');
      setEmail('');
      setMessage('')
      setNumber('')

  }catch (error) {
    setIsSuccess(false);
    }
  };


  
  /**
 * @function handleName
 * @description Updates the `name` state based on user input in the name field.
 * @param {React.ChangeEvent<HTMLInputElement>} e - The input change event.
 */
  const handleName = (e) => setName(e.target.value);

  /**
 * @function handleName
 * @description Updates the `name` state based on user input in the name field.
 * @param {React.ChangeEvent<HTMLInputElement>} e - The input change event.
 **/
  const handleNumber = (e) => setNumber(e.target.value)



  /**
    * 
 * @function handleEmail
 * @description
 * Updates the `email` state based on user input and validates the email format.
 * If the email is invalid, sets `isValidMail` to true and resets success state.
 * Otherwise, clears error and invalid email flags.
 * 
 * @param {React.ChangeEvent<HTMLInputElement>} e - The input change event.
 */
  const handleEmail = (e) => {
    setEmail(e.target.value)
    if (!isValidEmail(e.target.value)) {
      setIsSuccess(false);
      setIsValidMail(true);
      return;
    } else {
      setError(false)
      setIsValidMail(false);
    }
  };
  


  return (
    <div className='INCSUBContact_ctn'>
      <div className='INCSUBContact_ctn_content'>

      <INCSUBCommonHeading text='Contact Us' />
      <div className='INCSUBContact_form_ctn'>
        <form className='INCSUBContact_form' onSubmit={(e) => e.preventDefault()} >
          <input onChange={handleName} type="text" id="name" name="name"  placeholder='Enter Name' value={name}
            style={{ borderColor:  error && name?.trim() === '' ? 'red' : null }}
          />
          <input  onChange={handleEmail} type="email" id="email" name="email"  placeholder='Enter email' value={email} 
            style={{ borderColor:  error && email === '' ? 'red' : null }}
          />
          <input  onChange={handleNumber}  id="email" name="email"  placeholder='Phone number' value={number}  maxLength="10"
            onKeyPress={(event) =>
                event.key >= 0 && event.key <= 9 ? true : event.preventDefault()
              }
            style={{ borderColor:  error && number === '' ? 'red' : null }}
            type="tel"
              required
          />
          <textarea  onChange={handleMessage} id="message" name="message" rows="5"  placeholder='Enter Message' value={message}></textarea>
          <button onClick={!isSuccess ? handleSubmit : null}>{isSuccess ? <div className='btnLoader'></div> : "Submit"}</button>
        </form>
      </div>
      </div>
      <INCSUBFooter />
    </div>
  )
}

export default INCSUBContact
